import React from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { enviarEmail } from "../../utils/enviarEmail";
import { Formulario } from "../form";

import LOGO from "../../utils/SVG/LOGO-BRANCA.svg";

import { color } from "../../utils/colors";
import "../../utils/font-roboto.scss";
import "./index.scss";

import { useTranslation } from "react-i18next";


const Footer = () => {
        const { t  } = useTranslation();
  return (
    <div className="rodape-container">
      <div className="barra-newsletter">
        <div className="inscrevase">
          <div className="texto bold px24">{t('contato.inscrever')}</div>
          <div className="texto px20">{t('contato.newsletter')}</div>
        </div>
        <div className="formulario">
          <Formulario emailCampo flexLinha apiEnvio={""} textoBotao={t('contato.botao')}/>
        </div>
      </div>
      <div className="linha" />
      <div
        className="logo-email"
        style={{ backgroundColor: color?.barra, width: "100%" }}
      >
        <div
          className="LOGO"
          style={{
            backgroundImage: `url(${LOGO})`,
          }}
        />
        <div className="redes-sociais" style={{marginRight:'12.5%'}}>
          <div className="caixa px18">
            <div className="email-link" onClick={() => enviarEmail()}>
              <FontAwesomeIcon icon={faEnvelope} />
              <div>comercial@brweapons.com.br</div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="copyright px16"
        style={{ backgroundColor: color?.escuro }}
      >
        {t('rodape')}
      </div>
    </div>
  );
};

export default Footer;
